import { signProps } from "types/paymentMethods";
import { ResetIcon } from "icons/payments/ResetIcon";
import { UploadIcon } from "icons/payments/UploadIcon";
import React from "react";
import SignaturePad from "react-signature-canvas";
import { useTestAttrsFactory } from "utils/testid";

interface SignComponentProps {
  selectedValue: string;
  signData: signProps;
  setSignData: any;
  handleBeginDrawing: () => void;
  handleDivClick: () => void;
  onFileInputChanges: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sigCanvas: any;
  isDrawing: boolean;
  fileInputRef: any;
  clear: () => void;
}

const SignatureComponent = ({
  selectedValue,
  signData,
  setSignData,
  handleBeginDrawing,
  onFileInputChanges,
  isDrawing,
  handleDivClick,
  fileInputRef,
  sigCanvas,
  clear,
}: SignComponentProps) => {
  const testAttrs = useTestAttrsFactory();

  return (
    <>
      {selectedValue === "Create Signature" ? (
        <>
          <div
            className="w-full mt-5 "
            {...testAttrs("typed-signature-panel", "Typed signature")}
          >
            <div className="w-full">
              <input
                placeholder="John Smith"
                aria-label="Typed signature"
                {...testAttrs("typed-signature-input")}
                value={signData.signTitle}
                onChange={(e) => {
                  if (e.target.value.length < 30) {
                    setSignData((prevData: any) => ({
                      ...prevData,
                      signTitle: e.target.value,
                    }));
                  }
                }}
                type="text"
                className="w-full border-strokePrimary outline-none focus-visible:none py-3 px-[15px] rounded-[5px] border-[1px]"
              />
            </div>
            <div
              className="signInputClass flex justify-center items-center mt-3 rounded-[5px] border-[1px] border-strokePrimary h-[110px] text-[50px]"
              {...testAttrs(
                "typed-signature-preview",
                "Typed signature preview"
              )}
            >
              {signData.signTitle}
            </div>
          </div>
        </>
      ) : selectedValue === "Draw Signature" ? (
        <>
          <div
            className="relative mt-5"
            {...testAttrs("draw-signature-panel", "Draw signature")}
          >
            <SignaturePad
              onBegin={() => handleBeginDrawing()}
              ref={sigCanvas}
              canvasProps={{
                className: "signatureCanvas",
                // "data-testid": "action-payment-draw-signature-canvas",
                "aria-label": "Draw signature canvas",
              }}
            />

            {isDrawing && (
              <>
                <div
                  className="absolute top-3 right-4 flex gap-1 cursor-pointer"
                  role="button"
                  tabIndex={0}
                  {...testAttrs(
                    "reset-drawn-signature",
                    "Reset drawn signature"
                  )}
                  onClick={clear}
                >
                  <ResetIcon aria-hidden="true" />
                  <p className="text-sm font-normal text-btnPrimaryActive">
                    Reset
                  </p>
                </div>
              </>
            )}

            {!isDrawing && (
              <>
                <div className="absolute top-[40%] left-[25%] lg:w-fit w-1/2 text-center text-base text-txtSecondary">
                  Draw your signature using mouse
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div
            className="flex justify-center items-center h-[172px] mt-5 rounded-[5px] border-[1px] border-strokePrimary text-txtSecondary text-base"
            role="button"
            tabIndex={0}
            {...testAttrs("upload-signature-panel", "Upload signature")}
            onClick={handleDivClick}
          >
            {signData?.file ? (
              <>
                <div className="flex flex-col gap-2 items-center">
                  <div className="max-w-40 w-[260px] max-h-[100px] h-[100px]">
                    <img
                      src={signData.fileUrl}
                      alt="Uploaded signature"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="text-xs font-medium text-txtSecondary">
                    {signData?.file.name}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center gap-1">
                  <UploadIcon aria-hidden="true" /> Upload document
                </div>
                <input
                  type="file"
                  id="inputFiles"
                  accept="image/png, image/jpeg"
                  aria-label="Upload signature file"
                  {...testAttrs("upload-signature-input")}
                  onChange={(e) => onFileInputChanges(e)}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SignatureComponent;
